import React from "react";

export const SvgTea = () => {
	return (
		<svg
			width="13"
			height="10"
			viewBox="0 0 13 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.14924e-05 7.99593H12.5259C12.5259 8.55705 12.348 9.01801 11.9924 9.41887C11.6369 9.8197 11.2219 10 10.7281 10H1.77812C1.28421 10 0.86934 9.79958 0.513748 9.41887C0.177875 8.99804 3.14924e-05 8.55705 3.14924e-05 7.99593ZM12.2097 0.821614C12.7431 1.36274 13 2.004 13 2.74552C13 3.50708 12.7431 4.14834 12.2097 4.66943C11.6762 5.21055 11.044 5.47112 10.313 5.47112H9.85854V5.69154C9.85854 6.1324 9.70053 6.49323 9.40411 6.81379C9.08795 7.13449 8.73236 7.27475 8.29774 7.27475H3.37839C2.94377 7.27475 2.58805 7.11447 2.27202 6.81379C1.95586 6.4931 1.81758 6.1324 1.81758 5.69154V0.460976C1.81758 0.340698 1.85715 0.240551 1.95588 0.140282C2.03489 0.0601386 2.15346 0 2.27204 0H10.3329C11.0442 0.0198784 11.6766 0.280434 12.2099 0.821559L12.2097 0.821614ZM11.7356 3.98804C12.0715 3.64734 12.2493 3.20648 12.2493 2.72552C12.2493 2.22453 12.0715 1.8037 11.7356 1.463C11.3997 1.12231 10.9651 0.941878 10.491 0.941878H9.8982V4.5292H10.491C10.965 4.52907 11.3799 4.34878 11.7356 3.98807V3.98804Z"
				fill="#666666"
			/>
		</svg>
	);
};
